module.exports = __webpack_public_path__ + "img/Boolflix-big-logo.8a4701e9.png";